<div class="row sam-form-flex" *ngIf="actionSetting$ | async as actionSettings">
   <div class="k-form-field">
      <label class="sam-center-left sam-margin-left-medium" fxFlex="40%" for="{{ actionId }}-call-position">
         {{ 'user_actions.types.requeue_call.settings.call_position' | translate }}
      </label>
      <kendo-dropdownlist
         fxFlex="60%"
         id="{{ actionId }}-call-position"
         [value]="actionSettings.callPosition"
         [data]="[1, 2, 3, 4, 5, 6, 7, 8, 9]"
         (valueChange)="callPositionChanged(actionSettings, $event)"
      >
      </kendo-dropdownlist>
   </div>
   <div class="k-form-field">
      <label class="sam-center-left sam-margin-left-medium" fxFlex="40%" for="{{ actionId }}-call-position">
         {{ 'user_actions.types.requeue_call.settings.requeue_target' | translate }}
      </label>
      <kendo-dropdownlist
         fxFlex="60%"
         [data]="filteredSelectableQueues$ | async"
         [filterable]="true"
         [textField]="'name'"
         [valueField]="'id'"
         [loading]="isLoadingSelectableQueues$ | async"
         [value]="selectedQueue$ | async"
         (valueChange)="selectQueue(actionSettings, $event)"
         (filterChange)="searchTextChanged($event)"
      >
         <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
            <div class="sam-margin-right">
               <fa-icon
                  [icon]="(dataItem.queueTypeId | toQueueType).icon"
                  [fixedWidth]="true"
                  *ngIf="dataItem"
               ></fa-icon>
            </div>
            {{ dataItem?.name }}
         </ng-template>
         <ng-template kendoDropDownListNoDataTemplate>
            <h4>
               <fa-icon [icon]="noDataIcon"></fa-icon><br /><br />
               {{ 'samwin.queue_selection_dialog.no_queues_available' | translate }}
            </h4>
         </ng-template>
      </kendo-dropdownlist>
   </div>
</div>
